module.exports = __webpack_public_path__ + "img/chiku01.074c97e8.png";